module.exports = __webpack_public_path__ + "img/mainback3.9ab339e8.jpg";